import React from 'react';
import {Translation} from 'react-i18next';
import {Form, Select} from 'antd';


const OneTimePasswordInput = ({name, label, fieldKey=null, rules=null, disabled=false, ...props}) => {

  const options = [
    {
      value: 1,
      label: "roles_input_one_time_password_off",
    },
    {
      value: 2,
      label: "roles_input_one_time_password_optional",
    },
    {
      value: 3,
      label: "roles_input_one_time_password_on",
    },
  ];

  return (
    <Translation>{(t) => 
      <div className="form-group">
        <Form.Item
          name={name || 'one_time_password'}
          fieldKey={fieldKey}
          label={label || t('roles_one_time_password')}
          rules={rules}
        >
          <Select disabled={disabled}>
            {options.map(x => <Select.Option key={x.value} value={x.value}>{t(x.label)}</Select.Option>)}
          </Select>
        </Form.Item>
      </div>
    }</Translation>
  );
}

export default OneTimePasswordInput;
